var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-center",staticStyle:{"height":"calc(100vh - 40px)","color":"var(--faqTextColor)","background-color":"var(--faqBackgroundColor)"}},[_c('h1',{staticClass:"help-header"},[_vm._v("\n    Help Center\n  ")]),_vm._v(" "),_c('support-article-viewer',{staticStyle:{"margin":"25px 30px 16px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc7292d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/support/HelpCenter.vue
// module id = null
// module chunks = 